import { JSX, PropsWithChildren, useState } from 'react'
import CourseEditorBox from './CourseEditorBox'
import { Icon } from '@bm-js/atlascloud-ui'
import { LucideIconName } from '@bm-js/atlascloud-shared'

type Props = {
  header: JSX.Element | string
  extraActions?: JSX.Element
}

const CourseEditorExpandCard = ({
  header,
  children,
  extraActions,
}: PropsWithChildren<Props>) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <CourseEditorBox>
      <div className='flex w-full items-center'>
        {typeof header === 'string' ? (
          <p
            className='flex-grow cursor-pointer'
            onClick={() => setIsOpen(!isOpen)}
          >
            {header}
          </p>
        ) : (
          header
        )}
        <button className='flex items-center gap-2'>
          {extraActions}
          <Icon
            onClick={() => setIsOpen(!isOpen)}
            name={isOpen ? LucideIconName.X : LucideIconName.Plus}
            className={`h-5 w-5 cursor-pointer`}
          />
        </button>
      </div>
      <div
        className={`max-h-[0] transition-all ${
          isOpen ? 'max-h-[1000px] overflow-y-auto pt-4' : 'overflow-hidden'
        }`}
      >
        {children}
      </div>
    </CourseEditorBox>
  )
}

export default CourseEditorExpandCard
